import type { BankInfo } from '@/store/order/OrderStore';

export enum FormInfomation {
  Product = 'product',
  Profile = 'profile',
  H5PreApply = 'H5PreApply',
  Repay = 'repay',
  /** 授信结果页自营绑卡场景（自营8180无绑卡记录）,从新项目通过打开webview方式跳转过来
   * 此场景不存在数字人民币情况，故为兼容数字人民币场景
   */
  Credit = 'credit',
  QuickWithdraw = 'quickWithdraw',
}

/** 绑卡页场景对应中文映射
 * [FormInfomation.Profile] 和 [FormInfomation.H5PreApply] 目前不会走进绑卡页面
 */
export const BindingCardChineseCMap: Partial<Record<FormInfomation, string>> = {
  [FormInfomation.Product]: '提现',
  [FormInfomation.Repay]: '还款',
  [FormInfomation.Credit]: '授信',
};

export interface SessionFrom {
  back: string;
  from?: string;
  commodityId?: string;
}

export interface SessionBindedCard {
  commodityId: string;
  bankInfo: BankInfo;
}
